import AnimatedCarousel, { AnimatedCarouselProps } from "./AnimatedCarousel";

export { AnimatedCarousel, AnimatedCarouselProps };

export default AnimatedCarousel;
